import { getConfig } from 'config';
import { AgencySettings, AgencySettingsResponse } from './types';

const cache = new Map<string, AgencySettings>();
const inFlight = new Map<string, Promise<AgencySettings>>();

const getSiteKey = (): string => window.location.hostname;

export const initAgencySettings = async (): Promise<void> => {
  const siteKey = getSiteKey();

  if (cache.has(siteKey)) {
    return;
  }

  if (inFlight.has(siteKey)) {
    await inFlight.get(siteKey)!;
    return;
  }

  const promise = (async () => {
    const url = `${getConfig('API_ENDPOINT')}Agency/${siteKey}/Settings`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Unable to load agency settings from ${url}`);
    }
    const data = (await response.json()) as AgencySettingsResponse;
    cache.set(siteKey, data.settings);
    inFlight.delete(siteKey);
    return data.settings;
  })();

  inFlight.set(siteKey, promise);

  await promise;
};

export const agencySettingsStore = {
  get(): AgencySettings | null {
    return cache.get(getSiteKey()) ?? null;
  },
  async getOrLoad(): Promise<AgencySettings> {
    await initAgencySettings();
    return cache.get(getSiteKey())!;
  },
  clear(): void {
    const siteKey = getSiteKey();
    cache.delete(siteKey);
    inFlight.delete(siteKey);
  },
};
